import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgIPhone(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="12 7 36 45"
      fill="none"
      {...props}
    >
      <path
        stroke={props.primaryColor}
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M45.244 23.243c-.232.18-4.33 2.488-4.33 7.62 0 5.936 5.214 8.038 5.37 8.09-.024.128-.828 2.876-2.748 5.676-1.714 2.464-3.5 4.924-6.22 4.924-2.722 0-3.422-1.58-6.562-1.58-3.06 0-4.148 1.632-6.636 1.632s-4.226-2.28-6.22-5.08c-2.316-3.288-4.182-8.4-4.182-13.246 0-7.776 5.056-11.9 10.034-11.9 2.644 0 4.848 1.736 6.508 1.736 1.58 0 4.044-1.84 7.052-1.84 1.14 0 5.236.102 7.934 3.968Zm-9.36-7.26c1.242-1.478 2.122-3.526 2.122-5.574q.002-.406-.076-.804c-2.024.076-4.432 1.348-5.884 3.032-1.14 1.296-2.204 3.344-2.204 5.42 0 .312.052.624.076.724.128.024.336.052.544.052 1.816 0 4.1-1.216 5.42-2.852z"
      />
      <path
        stroke={props.secondaryColor}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M19.87 37.003c-.471 3.487 2.14 7.258 5.462 8.259"
      />
    </svg>
  );
}
export default SvgIPhone;
